<!-- my-loader.component.html -->
<div class="lms-global-spinner progress-loader" *ngIf="loading">
  <div class="loading-spinner">
    <div class="spinner-border text-light" role="status">
      <span class="visually-hidden">Loading...</span>
    </div>
  </div>
</div>
